import datatable from 'components/datatable'
import env from 'constants/env'
import { user, permits} from 'services'
import moment from 'moment'

const components = {
  datatable,
}

const directives = {

}

const computed = {

}

const methods = {
  // runReport() {
  //   // Validation
  //   this.do_search = false
  //   this.do_search = true
  // }
  setCols () {
    this.columns = [
      {name: "ID", object_name: "reservation_number", sortable: true, sort_key: "reservation_number"},
      {name: "Location", object_name: "location_name"},
      {name: "Arrangement", object_name: "arrangement", visible: this.user.type != 'channel'},
      {name: "Unit Type", object_name: "unit_type", visible: this.user.type != 'channel'},
      {name: "Modified", object_name: "modified"},
      {name: "Cancelled", object_name: "cancelled"},
      {name: "Channel", object_name: "channel", visible: this.user.type != 'channel'},
      {name: "Customer Name", object_name: "guest_name", visible: this.user.type != 'channel'},
      {name: "Email", object_name: "email", visible: this.user.type != 'location'},
      {name: "From", object_name: (obj, parent) => {
        return moment(obj.from_date, ['YYYY-MM-DD HH:mm:ss']).format('MM/DD/YYYY');
      }},
      {name: "To", object_name: (obj, parent) => {
        return moment(obj.to_date, ['YYYY-MM-DD HH:mm:ss']).format('MM/DD/YYYY');
      }},
      {name: "Currency", object_name: "currency"},
      {name: "Subtotal", object_name: "subtotal"},
      {name: "Total Discount", object_name: "total_discount", visible: this.user.type != 'channel'},
      {name: "Partial Refund", object_name: "partial_refund"},
      {name: "Grand Total", object_name: "grand_total"},
      {name: "Location Commission", object_name: "commissions_total"},
      {name: "Channel Commission Total", object_name: "channel_commissions_total", visible: this.user.type == 'channel'},
      {name: "Location Taxes", object_name: "total_tax"},
      {name: "Location Fees", object_name: "location_fees_total", click: (data) => this.$emit('locationFeesClicked', {
        location_id: data.history[data.history.length - 1].location_id,
        reservation_id: data.reservation_id
      }),
      classes: ['pointer']},
      {name: "Due at Lot", object_name: "due_at_location"},
      {name: "Location Total Amount", object_name: "location_total", visible: this.user.type != 'channel'},
      {name: "Location Lease Total Amount", object_name: "location_lease_total", visible: this.user.type == 'ims'},
      {name: "Pay to location", object_name: "pay_to_location", visible: this.user.type == 'ims'},
      {name: "Room Supplier", object_name: "room_supplier", visible: permits.hasPermit('super_admin')},
      {name: "eSIM Supplier", object_name: "esim_supplier", visible: permits.hasPermit('super_admin')},
      {name: "Vehicle Protection Supplier", object_name: "veh_prot_supplier", visible: permits.hasPermit('super_admin')},
      {name: "Total Supplier", object_name: "total_supplier", visible: permits.hasPermit('super_admin')},
      {name: "Owed Amount", object_name: "owed_amount", visible: this.user.type == 'ims' || this.user.type == 'channel'},
      {name: "Reslab fees", object_name: "reslab_fees", visible: this.user.type == 'ims' || this.user.type == 'channel'},
      {name: "# Of Parking", object_name: "number_of_parkings", visible: this.user.type != 'channel'},
      {name: "# Of Rooms", object_name: "number_of_rooms", visible: this.user.type != 'channel'},
      {name: "Number of Parking Commission Days", object_name: "number_of_commission_days", visible: this.user.type != 'channel'},
      {name: "Number of Parking Lease Days", object_name: "number_of_lease_days", visible: this.user.type == 'ims'},
      {name: "Creation Date", object_name: (obj, parent) => {
        return moment(obj.creation_date, ['YYYY-MM-DD HH:mm:ss']).format('MM/DD/YYYY');
      }, sortable: true, sort_key: "creation_date"},
      {name: "Previous Location Total Amount", object_name: "previous_location_total", visible: this.user.type != 'channel'},
      {name: "Previous Location Lease Total Amount", object_name: "previous_location_lease_total", visible: this.user.type == 'ims'},
      {name: "Previous Owed Amount", object_name: "previous_owed_amount", visible: this.user.type == 'ims' || this.user.type == 'channel'},
    ]
  },

  displayErrors (errors) {
    this.$emit('commissionPickupErrors',errors);
  }
}

export default {
  name: 'reports-overall-commission_pickup',
  props: ['url', 'feesBreakDown'],
  computed,
  components,
  directives,
  methods,
  data () {
    return {
      // loading: true,
      processing: false,
      errors: {},
      user: null,
      // do_search: false,
      columns: []
    }
  },
  created () {
  },

  mounted () {
    this.user = user.getUser();
    this.setCols();
  }
}
